module.exports = __webpack_public_path__ + "img/right.dc0190fe.svg";